import React from 'react';

const ErrorIcon = ({ width = 20, height = 20, style = {} }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ flexShrink: 0, ...style }}
  >
    <circle cx="10" cy="10" r="10" fill="#FF5B5B" />
    <path d="M10 5.5V11" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <circle cx="10" cy="13.5" r="1" fill="white" />
  </svg>
);

export default ErrorIcon;
